"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _format = _interopRequireDefault(require("date-fns/format"));
var _date = require("../../utils/date");
var _excluded = ["format"];
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var Countdown = /*#__PURE__*/function (_React$PureComponent) {
  function Countdown(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, Countdown);
    _this = _callSuper(this, Countdown, [props]);
    _this.state = {
      seconds: props.seconds
    };
    return _this;
  }
  (0, _inherits2["default"])(Countdown, _React$PureComponent);
  return (0, _createClass2["default"])(Countdown, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.launch();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.reset();
    }
  }, {
    key: "launch",
    value: function launch() {
      var _this2 = this;
      this.reset();
      this.timer = setInterval(function () {
        return _this2.tick();
      }, 1000);
    }
  }, {
    key: "reset",
    value: function reset() {
      clearInterval(this.timer);
    }
  }, {
    key: "tick",
    value: function tick() {
      var _this3 = this;
      var onStop = this.props.onStop;
      this.setState(function (prevState) {
        if (prevState.seconds <= 0) {
          _this3.reset();
          onStop();
          return {
            seconds: 0
          };
        }
        return {
          seconds: prevState.seconds - 1
        };
      });
    }
  }, {
    key: "render",
    value: function render() {
      var seconds = this.state.seconds;
      var _this$props = this.props,
        format = _this$props.format,
        props = (0, _objectWithoutProperties2["default"])(_this$props, _excluded);
      if (!seconds) {
        return null;
      }
      return /*#__PURE__*/_react["default"].createElement(StyledCountdown, props, Countdown.formattedValue(seconds, format));
    }
  }], [{
    key: "formattedValue",
    value: function formattedValue(seconds) {
      var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'HH:mm:ss';
      var dutation = (0, _date.getDurationTime)({
        seconds: seconds
      });
      return (0, _format["default"])(dutation, format);
    }
  }]);
}(_react["default"].PureComponent);
Countdown.propTypes = {
  onStop: _propTypes["default"].func,
  className: _propTypes["default"].string,
  format: _propTypes["default"].string,
  seconds: _propTypes["default"].number.isRequired
};
Countdown.defaultProps = {
  className: '',
  format: 'HH:mm:ss',
  onStop: Function.prototype
};
var StyledCountdown = _styledComponents["default"].div.withConfig({
  displayName: "Countdown__StyledCountdown",
  componentId: "sc-1eawtsb-0"
})(["font-size:17px;font-weight:500;"]);
var _default = exports["default"] = Countdown;